import Modal from "./_bootstrapModalExtensions";
import * as Url from "./Utils/UrlUtil";
import { CheckIfFilingNumberExistsInEKEIDR } from "./_ekeidr";
import { RefreshTopPartial } from "./pages/processActionEdit";
import Classes from "./_classes";

export function OnFinalizeSubmission(event: JQuery.Event, documentCount: number) {
    event.preventDefault();
    $('#finalize-submission-button').attr('disabled', 'disabled');

    if (documentCount == 0) {
        Modal.showConfirmationWindowAsync(
            'Biztos benne, hogy nem csatol dokumentumokat az irathoz?',
            'Kérelem benyújtása',
            function () {
                $('#rdprocessaction-submission-form').submit();
            },
            function () {
                $('#finalize-submission-button').removeAttr('disabled');
                return false;
            },
            'Igen',
            'Nem');

        return;
    }

    Modal.showConfirmationWindowAsync(
        'Biztosan be szeretné nyújtani?',
        'Kérelem benyújtása',
        function () {
            $('#rdprocessaction-submission-form').submit();
        },
        function () {
            $('#finalize-submission-button').removeAttr('disabled');
            return false;
        },
        'Igen',
        'Nem');

    return;
}

export function SetFilingNumber(event: JQuery.ClickEvent) {
    event.preventDefault();
    event.stopPropagation();

    let processActionId = $(event.target).data('processaction-id');
    let filingId = $(event.target).data('filing-id');
    let isIncoming = $(event.target).data('isincoming');

    let contentUrlTemplate = window.ETDR_RD.appConfig['UrlTemplate.GetEditFilingNumberForm'];
    let saveUrlTemplate = window.ETDR_RD.appConfig['UrlTemplate.UpdateFilingNumber'];

    const filingNumberUpdateSettings: Classes.BootstrapModalWithAjaxContentSettings = GetFilingNumberUpdateSettings();
    Modal.showBootstrapModalWithAjaxContent(filingNumberUpdateSettings);

    function GetFilingNumberUpdateSettings(): Classes.BootstrapModalWithAjaxContentSettings {
        let settings: Classes.BootstrapModalWithAjaxContentSettings = new Classes.BootstrapModalWithAjaxContentSettings();

        settings.title = 'Iktatószám megadása';
        settings.contentUrl = Url.createUrlFromTemplate(contentUrlTemplate, { filingId: filingId });
        settings.saveUrl = Url.createUrlFromTemplate(saveUrlTemplate, { filingId: filingId, isIncoming: isIncoming });
        settings.callback = data => callback(data);

        return settings;
    }

    function callback(data): void {
        $('#filing-number').html(data.filingNumber);
        $('#filing-date').html(data.filingDate);
        $('#filing-asking-clerk-name').html(data.clerkName);

        if (window.ETDR_RD.appConfig['User.CanUseEKEIDRService'] === true) {
            CheckIfFilingNumberExistsInEKEIDR('#errorDiv', data.filingNumber, false);
        }

        RefreshTopPartial(processActionId);
    }
}

export function OnStatisticalIndicatorsTabPageDisplayed() {
    let addedEKEIDRIndicatorsGridView = window['addedEKEIDRIndicators'] as MVCxClientGridView;
    let allEKEIDRIndicatorsGridView = window['allEKEIDRIndicators'] as MVCxClientGridView;

    addedEKEIDRIndicatorsGridView.Refresh();
    allEKEIDRIndicatorsGridView.Refresh();
}

export function SetReceiptNumber(event: JQuery.ClickEvent) {
    event.preventDefault();
    event.stopPropagation();

    let processActionId = $(event.target).data('processaction-id');
    let filingId = $(event.target).data('filing-id');

    let contentUrlTemplate = window.ETDR_RD.appConfig['UrlTemplate.GetEditReceiptNumberForm'];
    let saveUrlTemplate = window.ETDR_RD.appConfig['UrlTemplate.UpdateReceiptNumber'];

    const receiptNumberUpdateSettings: Classes.BootstrapModalWithAjaxContentSettings = GetReceiptNumberUpdateSettings();
    Modal.showBootstrapModalWithAjaxContent(receiptNumberUpdateSettings);

    function GetReceiptNumberUpdateSettings(): Classes.BootstrapModalWithAjaxContentSettings {
        let settings: Classes.BootstrapModalWithAjaxContentSettings = new Classes.BootstrapModalWithAjaxContentSettings();

        settings.title = 'Érkeztetőszám megadása';
        settings.contentUrl = Url.createUrlFromTemplate(contentUrlTemplate, { filingId: filingId });
        settings.saveUrl = Url.createUrlFromTemplate(saveUrlTemplate, { filingId: filingId });
        settings.callback = (data) => callback(data);

        return settings;
    }

    function callback(data): void {
        $('#receipt-number').html(data.receiptNumber);
        $('#receipt-date').html(data.receiptDate);
        $('#receipt-asking-clerk-name').html(data.clerkName);

        RefreshTopPartial(processActionId);
    }
}

export function SetFilingNumberEKEIDR(event: JQuery.ClickEvent) {
    event.preventDefault();
    event.stopPropagation();

    let processActionId = $(event.target).data('processaction-id');
    let filingId = $(event.target).data('filing-id');

    $.ajax({
        method: 'POST',
        url: window.ETDR_RD.appConfig["UrlAction.IktatEKEIDR"],
        data: { processActionId, filingId },
        success: function (data) {
            if (data.success) {
                $('#filing-number').html(data.filingNumber);
                $('#filing-date').html(data.filingDate);
                $('#filing-asking-clerk-name').html(data.clerkName);

                RefreshTopPartial(data.processActionId);
            }
        }
    });
}

export function OpenProcessActionOnRowClick(s: MVCxClientGridView, e: ASPxClientGridViewSelectionEventArgs, officeIdForFilingAdditionalData: number) {
    let rowKey: string = s.GetRowKey(e.visibleIndex);
    let rowKeyAsArray: string[] = rowKey.split('|');
    let actionId: number = parseInt(rowKeyAsArray[0]);

    OpenProcessActionEdit(actionId, officeIdForFilingAdditionalData);
}

export function OpenProcessActionEdit(processActionId: number, officeIdForFilingAdditionalData: number) {
    let template: string;
    let loc: string;
    let url: string;

    if (!officeIdForFilingAdditionalData || officeIdForFilingAdditionalData == 0) {
        template = "UrlTemplate.ProcessActionEdit";
        loc = window.ETDR_RD.appConfig[template];
        url = Url.createUrlFromTemplate(loc, { processActionId: processActionId });
    } else {
        template = "UrlTemplate.ProcessActionEditForInspector";
        loc = window.ETDR_RD.appConfig[template];
        url = Url.createUrlFromTemplate(loc, { processActionId: processActionId, officeIdForFilingAdditionalData: officeIdForFilingAdditionalData });
    }

    location.href = url.toString();
}

$(document).on('click', '#finalize-submission-button', function (event) {
    OnFinalizeSubmission(event, $("#finalize-submission-button").data("document-count"));
});

$(document).on('click', '#filingButton', function (event) {
    SetFilingNumber(event);
});

$(document).on('click', '#receiptButton', function (event) {
    SetReceiptNumber(event);
});

$(document).on('click', '#ekeidrFilingButton', function (event) {
    SetFilingNumberEKEIDR(event);
});
